import { Outlet } from "react-router-dom";

export default function ExportLayout() {
  return (
    <div className="min-h-screen bg-white p-8 print:p-0">
      <Outlet />
    </div>
  );
}
